<template>
  <div class="questionnaires">
    <div class="content" v-show="!showSuccess">
      <div class="title">您收到的商品是否收货完整？</div>
      <div class="evaluate">
        <p :class="{'incomplete':isActive==1}" @click="switchWay(1)">
          <i class="iconfont icon-bumanyi1"></i>
          <span>不完整</span>
        </p>
        <p :class="{'complete':isActive==2}" @click="switchWay(2)">
          <i class="iconfont icon-manyi1"></i>
          <span>完整</span>
        </p>
      </div>
      <div class="logo">
        <img :src="imgPrex + detail.sellerLogo" alt />
        <span>{{detail.sellerName}}</span>
      </div>
      <div class="common van-hairline--bottom" v-for="(item,index) in detail.list" :key="index">
        <div class="common-top">
          <span>{{item.productName}}</span>
          <span>x{{item.count}}</span>
        </div>
        <div class="common-bottom">{{item.specInfo}}</div>
      </div>
      <div class="invite" @click="onSubmit">提交</div>
    </div>
    <div class="hasSubmit" v-show="showSuccess">
      <div class="success">
        <i class="iconfont icon-jinduquerentubiao"></i>
      </div>
      <div class="titles">该订单问卷已提交</div>
      <div class="return" @click="returnIndex">返回首页</div>
    </div>
  </div>
</template>

<script>
import { getIntactDegreeProduct, updateIntactDegree } from "@/api/buyer/index";
export default {
  data() {
    return {
      imgPrex: this.imgPrex,
      isActive: 2,
      showSuccess: false,
      detail: {}
    };
  },
  methods: {
    switchWay(index) {
      this.isActive = index;
    },
    onSubmit() {
      let obj = {
        orderId: this.GetQueryString("orderId"),
        intactDegree: this.isActive //1不完整,2完整
      };
      updateIntactDegree(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.showSuccess = true;
          document.body.style.backgroundColor = "#FFFFFF";
        } else {
          this.$toast(res.appStatus.message);
        }
      });
    },
    returnIndex() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            wx.miniProgram.switchTab({
              url: "/pages/bazaarIndex/bazaarIndex"
            });
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goAppIndex();
        } else {
          // ios环境
          window.webkit.messageHandlers.goAppIndex.postMessage("");
        }
      }
    },
    getIntactDegreeProductWay() {
      let obj = {
        orderId: this.GetQueryString("orderId")
      };
      getIntactDegreeProduct(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.detail = res.content;
        }else if(res.appStatus.errorCode == 3081) {
          this.showSuccess = true;
        }else {
          this.$toast(res.appStatus.message);
        }
      });
    }
  },
  mounted() {
    document.body.style.backgroundColor = "#F5F5F5";
    this.getIntactDegreeProductWay();
  },
  destroyed() {
    document.body.style.backgroundColor = "#FFFFFF";
  }
};
</script>

<style lang="scss" scoped>
.questionnaires {
  height: 100vh;
  // width: 100vh;
}
.content {
  width: 343px;
  margin-left: 16px;
  margin-top: 16px;
  padding: 24px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 5px;
  .logo {
    width: 321px;
    height: 56px;
    margin-top: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    background-color: #f8f8f8;
    border-radius: 5px;
    img {
      width: 46px;
      height: 46px;
      margin-right: 14px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 800;
    color: #333333;
  }
  .evaluate {
    font-size: 20px;
    margin-top: 22px;
    display: flex;
    p {
      width: 116px;
      height: 34px;
      margin: 0;
      color: #ffffff;
      background-color: #d8d8d8;
      border-radius: 50px;
      position: relative;
      i {
        width: 34px;
        text-align: center;
        height: 34px;
        line-height: 34px;
        font-size: 34px;
        position: absolute;
        left: 0px;
      }
      span {
        width: 98px;
        flex: 1;
        height: 34px;
        line-height: 34px;
        text-align: center;
        position: absolute;
        left: 18px;
      }
    }
    p:first-child {
      margin-right: 30px;
    }
    .incomplete {
      background-color: #62affe;
    }
    .complete {
      background-color: #ff5110;
    }
  }
  .common {
    width: 321px;
    height: 51px;
    margin: 0 15px;
    text-align: left;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .common-top {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }
    .common-bottom {
      font-size: 12px;
      color: #999999;
      margin-top: 2px;
    }
  }
  .invite {
    width: 343px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    bottom: 10px;
    left: 16px;
    right: 16px;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    background-color: #ff1310;
    border-radius: 25px;
  }
}
.hasSubmit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .success {
    color: #83ce35;
    i {
      font-size: 65px;
    }
  }
  .titles {
    font-size: 18px;
    font-weight: 800;
    color: #333333;
    margin-top: 13px;
  }
  .return {
    width: 139px;
    height: 38px;
    line-height: 38px;
    margin-top: 32px;
    text-align: center;
    font-size: 16px;
    color: #ff1310;
    border: 1px solid #ff1310;
    border-radius: 25px;
  }
}
</style>